var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#647A97",
    d: "M16.5 4A9.511 9.511 0 007 13.5c0 6.547 6.538 12.488 8.541 14.153a1.499 1.499 0 001.917 0c2-1.665 8.542-7.608 8.542-14.154A9.511 9.511 0 0016.5 4zm6.257 9.556L13.6 19.244a.56.56 0 01-.621-.018l-3.363-2.357a.31.31 0 01.006-.489l1.031-.864a.31.31 0 01.3-.052l1.479.882a.501.501 0 00.554-.028l1.759-1.3a.501.501 0 00-.035-.827l-3.618-2.244a.383.383 0 01.018-.605l1.038-.769a.386.386 0 01.364-.052l5.607 2.088a.5.5 0 00.456-.056l2.493-1.7c.347-.238.777-.32 1.187-.228a1.61 1.61 0 011.245 1.552 1.596 1.596 0 01-.743 1.379z"
  }))));
}
export default SvgAirport;